// @flow
import React, { useState, useEffect } from 'react';
import { graphql, navigate, useStaticQuery } from 'gatsby';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import scrollToComponent from 'react-scroll-to-component';

import { updatePairs as updateUIPairs } from '../../redux/ui';
import jsonLd from '../../json-ld';
import Header from '../Header/HeaderMerchant';
import HeaderMobile from '../Header/HeaderMerchantMobile';
import Steps from '../Header/Steps';
import Footer from '../Footer/Footer';
import FooterMobile from '../Footer/FooterMobile';
import Notification from './Notification';
import Loading from './Loading';
import Modal from './Modal';

import './Layout.scss';

const Anchor = React.forwardRef((props, ref) => <i id="anchor_cm" ref={ref} />);

const Layout = ({
  children,
  isLoading,
  showModal,
  modalType,
  isNotificationVisible,
  isBtnToTopNeeded,
  merchantType,
  indicatedMerchantType,
  page,
}: {
  children: React$Node,
  isLoading: boolean,
  showModal: boolean,
  modalType: string,
  isNotificationVisible: boolean,
  isBtnToTopNeeded?: boolean,
  merchantType: string,
  indicatedMerchantType: string,
  page: string,
}) => {
  const anchor = React.createRef();
  const [isBtnToTopVisible, setIsBtnToTopVisible] = useState(false);

  // const onIdle = () => {
  //   _updateUIPairs({ isNotificationVisible: true });

  //   setTimeout(() => {
  //     _updateUIPairs({ isNotificationVisible: false });
  //   }, 2000);
  // };

  const data = useStaticQuery(graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
        keywords
        description
        canonical
        robots
      }
    }
  }
`)

  const metaRobots = data.site.siteMetadata.robots
    ? {
      name: `robots`,
      content: data.site.siteMetadata.robots,
    }
    : {};

  const btnToTopHandler = () => {
    if (window.scrollY > 508) {
      setIsBtnToTopVisible(true);
    } else {
      setIsBtnToTopVisible(false);
    }
  };

  const onClickToScroll = event => {
    event.preventDefault();

    scrollToComponent(anchor.current, {
      offset: 0,
      align: 'top',
      ease: 'inOutSine',
      duration: 300,
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', btnToTopHandler);

    btnToTopHandler();

    if (!indicatedMerchantType && !merchantType && page !== 'complete') {
      navigate('/');
    }

    return () => {
      window.removeEventListener('scroll', btnToTopHandler);
    };
  }, [indicatedMerchantType, merchantType, page]);





  return (
    <>
      <Helmet
        title={data.site.siteMetadata.title}
        meta={[
          {
            name: 'description',
            content: data.site.siteMetadata.description,
          },
          {
            name: 'keywords',
            content: data.site.siteMetadata.keywords,
          },
          metaRobots,
        ]}
        link={[
          {
            rel: 'canonical',
            href: data.site.siteMetadata.canonical,
          },
        ]}
        script={[
          {
            type: 'application/ld+json',
            innerHTML: JSON.stringify({
              ...jsonLd,
              description: data.site.siteMetadata.description,
            }),
          },
        ]}
      >
        <html lang="ja" />
      </Helmet>
      <div className="pc">
        <Header pathname={''} headerAlpha={0.9} />
      </div>
      <div className="sp">
        <HeaderMobile pathname={''} headerAlpha={0.9} />
      </div>

      {page !== 'complete' && <Steps merchantType={merchantType} />}
      <Anchor ref={anchor} />
      {/* eslint-disable-next-line */}
      {isBtnToTopNeeded && isBtnToTopVisible && (
        <button onClick={onClickToScroll} className="btn-back-to-top" />
      )}
      {children}
      <Notification isVisible={isNotificationVisible} />
      <Loading isLoading={isLoading} />
      {showModal && <Modal type={modalType} />}
      <div className="pc">
        <Footer isMerchant />
      </div>
      <div className="sp">
        <FooterMobile isMerchant />
      </div>
    </>
  );

};

Layout.defaultProps = {
  isBtnToTopNeeded: true,
};

const mapStateToProps = state => ({
  isLoading: state.ui.isLoading,
  showModal: state.ui.showModal,
  modalType: state.ui.modalType,
  isNotificationVisible: state.ui.isNotificationVisible,
  merchantType: state.uiToBeCached.merchantType,
});

const mapDispatchToProps = (dispatch: Function) => ({
  _updateUIPairs: pairs => dispatch(updateUIPairs(pairs)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Layout);